import { render } from "./channelDetail.vue?vue&type=template&id=20e55821&scoped=true"
import script from "./channelDetail.vue?vue&type=script&lang=js"
export * from "./channelDetail.vue?vue&type=script&lang=js"

import "./channelDetail.vue?vue&type=style&index=0&id=20e55821&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/test-event-admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20e55821"],['__file',"src/views/channel/components/channelDetail.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "20e55821"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('20e55821', __exports__)) {
    console.log('reload')
    api.reload('20e55821', __exports__)
  }
  
  module.hot.accept("./channelDetail.vue?vue&type=template&id=20e55821&scoped=true", () => {
    console.log('re-render')
    api.rerender('20e55821', render)
  })

}


export default __exports__